<template>
    <b-container class="info-text">
        <h3 class="text-center">
            Statement of Assurances
        </h3>
        <hr>
        <p>
            As a condition of receiving federal Strengthening CTE Education for the 21st Century
            (Perkins)funds, the recipient assures and certifies that the institution will comply
            with the following points. Failure to comply with these requirements may result in the
            delay of reimbursements and/or the return of funds.
        </p>
        <ol>
            <li>
                The institution will comply with all regulations, policies, guidelines, and
                requirements included in EDGAR and the Uniform Grant Guidance as they relate to the
                application, acceptance and use of federal funds. Activities funded will be
                necessary, reasonable, allocable and legally in compliance with federal
                regulations. Activities will be limited to postsecondary students enrolled in
                for-credit CTE programs.
            </li>
            <li>
                Perkins funds will be used to supplement state and local funds for career and
                technical education. Funds will not be used to support any activity or service that
                was funded by local or non-Perkins during any portion of the preceding academic
                year. In no case will Perkins funds be used to supplant state or local funds,
                including services required by federal, state or local law.
            </li>
            <li>
                Funded activities will support the focus areas identified in the Local Application
                and will take into consideration gaps and disparities identified through the
                Comprehensive Needs Assessment and stakeholder consultation.
            </li>
            <li>
                Program and financial reports and data submissions required for calculation of
                Perkins performance measurements will be complete, accurate, and submitted
                according to prescribed deadlines. This includes special populations information,
                technical skill assessment results or any other data required for Perkins
                accountability reports.
            </li>
            <li>
                Funded activities must contribute to successful performance of core indicators and
                be of sufficient size and scope as to be effective.
            </li>
            <li>
                Any equipment purchases included in this application should be installed no later
                than January 1 of the program year. Equipment will be visibly tagged as purchased
                with Perkins funds and inventoried no less than every two years. Equipment is
                defined as capital items and attractive assets, some of which may be below the
                institution’s capital outlay threshold.
            </li>
            <li>
                The institution will request reimbursements for expenditures at least quarterly.
                Funds must be obligated by June 30 of the program year and submitted for
                reimbursement no later than July 31 following the close of the program year. No
                requests for reimbursements will be accepted after this date. Rebates and credits
                must be applied during the program year and sales/use taxes must be submitted
                within the established timeframe in order to be reimbursed.
            </li>
            <li>
                A position description and personnel activity report (PAR) will be maintained for
                any position fully or partially funded by Perkins.
            </li>
            <li>
                If the recipient is a consortium, activities will be funded based on need and not
                the Pell count of individual members.
            </li>
        </ol>
        <b-form-row>
            <!-- <b-col>
                If you'd like to download this document, click
                <a :href="assurancesDownloadHref" target="_blank"> <strong>here</strong>. </a>
            </b-col> -->
        </b-form-row>
    </b-container>
</template>

<script>
export default {
    name: 'PerkinsStatementOfAssurances',

    // computed: {
    //     assurancesDownloadHref() {
    //         // we don't have an env variable for the API server root, but this works to strip the /api/vi bit
    //         return process.env.VUE_APP_API_URL + '../../downloads/perkins_statement_of_assurances_2018.pdf';
    //     },
    // },
};
</script>
